import { useLocalSearchParams } from "expo-router";
import React from "react";

import MatchItemView from "./MatchItemView";

import { ReportsPlayerMatchFragment } from "@/generated/graphql";

/**
 *
 */
interface Props {
  item: ReportsPlayerMatchFragment;
  onSelect: () => void;
  selectedMatchIds: string[];
}

/**
 * Container component that manages the match item display for report generation.
 * Extracts playerId from route params and passes data to the view component.
 * @param root0 - The component props
 * @param root0.item - Match data including opponent name, date, and match ID
 * @param root0.onSelect - Callback invoked when user selects/deselects this match for report
 * @param root0.selectedMatchIds - Array of currently selected match IDs to determine selection state
 */
const MatchItemContainer = ({ item, onSelect, selectedMatchIds }: Props) => {
  const { playerId } = useLocalSearchParams<{ playerId: string }>();
  return (
    <MatchItemView
      selectedMatchIds={selectedMatchIds}
      onSelect={onSelect}
      item={item}
      playerId={playerId}
    />
  );
};

export default MatchItemContainer;
